import { RewardType } from 'common/services/Enums';
import type {
  popupInterface,
  responseInterface,
  shippingOptionsResponse,
  binResponseInterface,
  cardObjectInterface,
  newPopupInterface,
  customPaymentTextResponseInterface,
  giftCardInterface,
  BankDetailsInterface,
  offersResponseInterface,
  cgsDataInterface,
  cardDetailsInputValidationInterface,
  giftCardRewardInterface,
  paymentButtonInterface,
  gstInfoInterface,
  ICardPayment,
  twidpayItemInterface,
  CodConfirmationBoxConfigsInterface,
  twidpayInterface,
  prepaidFreebieInterface,
  partnerAcquisitionOfferInterface,
  paymentOptionsHelperInterface,
  userAgentCompatibilityInterface,
  WebviewConfigInterface,
  ICodPayment,
  onplStoreInterface,
  otpFlowInterface,
  PrepaidCodUiConfigInterface,
  CredOfferInterface,
  StackingStoreInterface,
  gyftrInterface,
  PreferredPaymentPanel,
  CodSliderInterface,
  ShopifyStoreCreditInterface,
  utmDiscountInterface,
  SnapmintExpInterface,
  UpiAppConfig,
  mrpDiscountDataInterface,
  BankPlans,
  emiDetailsInterface,
  EmiOfferInterface,
  availableOffersInterface,
  WalletBnplPaymentsInterface,
  AppliedDiscountInterface,
  PreviousAddressAndShippingInterface,
} from '../services/Interfaces';

import { EMI_SCREENS, InititalConstants, PREFERRED_PANEL_TYPES, cardValidationError } from '../utils/ConstantVariables';
import { writable, type Writable } from 'svelte/store';

export const store_shippingRatesOptions: Writable<any> = writable(null);
export const store_selectedShippingMethod: Writable<shippingOptionsResponse> = writable(null);
export const store_shippingServiceablity: Writable<boolean> = writable(false);
export const store_shippingFetchedPincode: Writable<string | null> = writable(null);
export const store_useStoreCredit: Writable<boolean> = writable(false);
export const store_totalPrice: Writable<number> = writable(null);
export const store_discountAmount: Writable<number> = writable(null);
export const store_extraDiscountMatches: Writable<boolean> = writable(false);
export const store_cartAutoDiscount: Writable<boolean> = writable(false);
export const store_placeOrder: Writable<boolean> = writable(false);
export const store_discountedLevelSrates: Writable<boolean> = writable(false);
export const store_prepaidDiscount: Writable<number> = writable(0);
export const store_codCharges: Writable<number> = writable(0);
export const store_checkout_url: Writable<string> = writable(null);
export const store_original_checkout_url: Writable<string> = writable(null);
export const store_graphqlOrderId: Writable<string> = writable(null);
export const store_moid: Writable<string> = writable('');
export const store_gokwikOid: Writable<string> = writable('');
export const store_upiInfo: Writable<any> = writable({});
export const store_addressAdded: Writable<boolean> = writable(false);
export const store_order_name: Writable<string> = writable('');
export const store_uLink: Writable<string> = writable('');
export const store_recommendedCouponCode: Writable<string> = writable('');
export const store_continueShipping: Writable<boolean> = writable(false);
export const store_discountCallStatus: Writable<string> = writable('');
export const store_discountShipping: Writable<shippingOptionsResponse> = writable(null);
export const store_moveToAddressListing: Writable<boolean> = writable(false);
export const store_otpTab: Writable<Window> = writable(null);
export const store_abcDiscountAmount: Writable<number> = writable(null);
export const store_previousAddressAndShipping: Writable<PreviousAddressAndShippingInterface> = writable({
  address: null,
  shippingMethod: null,
});

export const store_cardPaymentFailed: Writable<ICardPayment> = writable({
  message: '',
  pending: false,
  failed: false,
  retryCardPayment: false,
});

export const store_codPaymentFailed: Writable<ICodPayment> = writable({
  message: '',
  pending: false,
  failed: false,
  retryCodPayment: false,
});
//Discount shipping service

export const store_shippingOptionsResponse: Writable<Array<shippingOptionsResponse>> = writable([]);
export const store_discountResponse: Writable<any> = writable(null);

// cc/dc payments
export const store_customerId: Writable<number> = writable(null);
export const store_selectedCard: Writable<cardObjectInterface> = writable(null);
export const store_bottomSheetState: Writable<popupInterface> = writable({
  showPopup: false,
  mode: '',
  component: null,
  componentData: null,
  showContinueButton: true,
  showCloseButton: true,
  topCloseButtonPos: false,
  paymentStatus: '',
  enableBackdropClick: false,
  hasTopBorder: false,
  showTopCloseButton: false,
  onClose: () => {},
  titleBold: false,
  noHeader: false,
  type: '',
  headerIconClass: '',
});
export const store_paymentId: Writable<string> = writable(null);
export const store_binResponse: Writable<binResponseInterface> = writable({
  isDomestic: false,
  issuingBank: '',
  cardType: '',
  cardCategory: '',
  shouldRedirect: false,
});
export const store_flipCardScreen: Writable<boolean> = writable(false);

export const store_cardOtpObject: Writable<{
  should_redirect?: boolean;
  is_resend_otp_supported: boolean;
  submit_otp_attempts: number;
  resend_otp_attempts: number;
  redirect_url: string;
  response: boolean;
  timer: number;
}> = writable({
  should_redirect: false,
  is_resend_otp_supported: false,
  submit_otp_attempts: 0,
  resend_otp_attempts: 0,
  redirect_url: '',
  timer: 0,
  response: false,
});

export const store_otpTabClosed: Writable<boolean> = writable(false);
export const store_freeProductAdded: Writable<boolean> = writable(false);
// export const store_availableOffers: Writable<availableOffersInterface[]> = writable(null);
//null for check so that when there is an array we know that we've received the response. In case of empty array, we wouldn't be able to differentiate between this and a 'no discounts' response.
export const store_availableOffersCheck: Writable<boolean> = writable(false);
export const store_userWithNoCard: Writable<boolean> = writable(false);
export const store_selectedCardCvv: Writable<string | null> = writable('');
export const store_payOptions: Writable<WalletBnplPaymentsInterface[]> = writable([]);
export const store_rtoCodConfirmation: Writable<Array<string>> = writable([]);
export const store_codConfirmation: Writable<boolean> = writable(false);
export const store_ppCodAmount: Writable<number> = writable(0);
export const store_deliveryEstimate: Writable<string> = writable('');
export const store_popupState: Writable<newPopupInterface> = writable({
  showPopup: false,
  state: '',
  component: {},
});
export const store_gwpDiscountCodes: Writable<Array<string>> = writable([]);
export const store_previousUpiLink: Writable<string> = writable('');
export const store_netbankingObject: Writable<{ status: boolean; text: string }> = writable({
  status: false,
  text: '',
});
export const store_retryCreate: Writable<boolean> = writable(false);
export const store_isHydrogen: Writable<boolean> = writable(false);
export const store_closeCodConfirmation: Writable<boolean> = writable(false);

export const store_giftCard: Writable<giftCardInterface[]> = writable([]);
export const store_giftCardTotal: Writable<number> = writable(0);
export const store_enableGiftCard: Writable<boolean> = writable(false);
export const store_showCaptcha: Writable<boolean> = writable(false);
export const store_captchaObject: Writable<{ captcha_type: string; risk_flag: string[] }> = writable({
  captcha_type: null,
  risk_flag: [],
});

export const store_showCodConfirmation: Writable<boolean> = writable(false);
export const store_disableClick: Writable<boolean> = writable(false);

export const store_emiPage: Writable<string> = writable(EMI_SCREENS.EXPLORE_PLANS);
//doubt
export const store_selectedEmiCard: Writable<any> = writable(null);
export const store_selectedEmiPlan: Writable<emiDetailsInterface | null> = writable(null);
export const store_selectedBank: Writable<BankPlans | null> = writable(null);
export const store_emiOffers: Writable<EmiOfferInterface | null> = writable(null);
export const store_cardlessEmi: Writable<Record<string, { planLength: number; selected: boolean }>> = writable({});

//payment page texts
export const store_paymentPageText: Writable<{
  codChargesText: string;
  codDisableReason: string;
  pageSubtitle: string;
  discountTitle: string;
  codAvailable: boolean;
  codReasonPosition?: string;
}> = writable({
  codChargesText: '',
  codDisableReason: '',
  pageSubtitle: 'Please select payment method to complete the order',
  discountTitle: '',
  codAvailable: true,
  codReasonPosition: '',
});
export const store_customPaymentText: Writable<customPaymentTextResponseInterface> = writable(
  InititalConstants.custom_payment_texts
);
export const store_customPaymentColors: Writable<{ [key: string]: string }> = writable({});
export const store_showDecimalValues: Writable<boolean> = writable(false);
export const store_alternateMobileUi: Writable<boolean> = writable(false);
export const store_showPrice: Writable<boolean> = writable(false);
export const store_ccProvider: Writable<string> = writable('');
export const store_upiProvider: Writable<string> = writable('');
export const store_callAllCards: Writable<boolean> = writable(false);
export const store_codDisableReason: Writable<string> = writable('');
export const store_netBankingBankList: Writable<Array<BankDetailsInterface>> = writable([]);
export const store_paymentAttempts: Writable<number> = writable(0);
export const store_transactionStatusDescription: Writable<string> = writable('');
export const store_estimatedDeliveryDate: Writable<{ [key: string]: string }> = writable({});
export const store_edd: Writable<{ edd_url: string; enable: boolean }> = writable({
  edd_url: '',
  enable: false,
});
export const store_allPlan: Writable<{
  creditCards?: BankPlans[];
  debitCards?: BankPlans[];
  bajajFinserv?: BankPlans[];
}> = writable({
  creditCards: [],
  debitCards: [],
  bajajFinserv: [],
});
export const store_methodShopifyCustomerId: Writable<string> = writable('');
export const store_codRedirectToNative: Writable<boolean> = writable(false);
export const store_rtoScore: Writable<cgsDataInterface> = writable({
  cgs_score: null,
  main_text: '',
  sub_text: '',
  heading: '',
});
export const store_cardDetails: Writable<{
  cardNumber: string;
  validThrough: string;
  cardHolderName: string;
  isDateValid: boolean;
}> = writable({
  cardNumber: '',
  validThrough: '',
  cardHolderName: '',
  isDateValid: false,
});
export const store_cardNumberLength: Writable<number> = writable(16);
export const store_cardNumberValidation: Writable<cardDetailsInputValidationInterface> = writable({
  error: false,
  message: cardValidationError.invalidCardNumber,
});
export const store_cardExpiryValidation: Writable<cardDetailsInputValidationInterface> = writable({
  error: false,
  message: cardValidationError.invalidExpiryDate,
});
export const store_cardCvvValidation: Writable<cardDetailsInputValidationInterface> = writable({
  error: false,
  message: cardValidationError.invalidCVV,
});
export const store_optionalEmail: Writable<boolean> = writable(false);
export const store_preferredPaymentPanel: Writable<PreferredPaymentPanel> = writable({
  isEnabled: false,
  type: PREFERRED_PANEL_TYPES.COMBINED_UPI_PANEL,
});
export const store_upiBadgeText: Writable<string> = writable('');
export const store_rtoDiscount: Writable<number> = writable(null);
export const store_offers: Writable<offersResponseInterface> = writable({
  discounts: [],
  reverifyDiscounts: false,
  unavailableDiscounts: [],
  loader: true,
});
export const store_bestOfferPresent: Writable<any> = writable({
  available: false,
  applied: false,
  title: '',
});
export let store_partnerAcquisitionOffer: Writable<partnerAcquisitionOfferInterface> = writable({
  loginPage: undefined,
  addressPage: undefined,
  cashbackAmount: 0,
  offerPartner: '',
  discountAmount: 0,
  isEligible: false,
  discountCode: '',
  isApplied: false,
  autoOfferId: '',
  manualOfferId: '',
  autoApply: false,
  callApi: false,
  viewInListing: false,
});
export let store_giftCardRewards: Writable<giftCardRewardInterface> = writable({
  code: '',
  applied: false,
  available: false,
  credits: 0,
  type: '',
  removeDiscount: false,
  flag: false,
});
export const store_selectedPaymentOptionButton: Writable<paymentButtonInterface> = writable({
  buttonText: '',
  status: false,
  type: '',
  methodType: '',
});

export const store_twidPay: Writable<twidpayInterface> = writable({
  status: false,
  allRewards: [],
  appliedReward: {
    amount: null,
    id: '',
    points: null,
    provider: '',
    type: '',
    issuer: 'brand',
    redemption_type: RewardType.BURN,
  },
  applyRewardId: '',
  applyRewardIdRedemptionType: '',
  paymentOffer: null,
  startPayment: null,
  callMethod: false,
  callTwid: true,
  autoApplied: true,
  show: true,
  freebieApplied: null,
  skippedTwidCardFlow: false,
  rewardApiRecalledOnDisableTiered: false,
  disableTieredWithTwid: false,
  disableDiscountWithTwid: false,
});

export const store_orderRetry: Writable<boolean> = writable(false);

export const store_gstInfo: Writable<gstInfoInterface> = writable({
  status: false,
  tax: null,
  taxInclusion: '',
});

export const store_minPrice: Writable<number> = writable(null);
export const store_snapchatAttributes: Writable<any> = writable({});

export const store_codConfirmationBoxConfigs: Writable<CodConfirmationBoxConfigsInterface> = writable({
  timerEnabled: false,
  promptMessage1: '',
  promptMessage2: '',
  promptMessage3: '',
  promptMessage4: '',
  timer: 30,
  navigateTo: '',
  toggleColours: false,
});

export const store_prepaidFreebie: Writable<prepaidFreebieInterface> = writable({
  valid: false,
  showConfirm: false,
  value: 0,
});

export const store_showAllUpis: Writable<boolean> = writable(false);
export const store_addressesMasked: Writable<boolean> = writable(false);
export const store_captureApiTimerId: Writable<number | null | ReturnType<typeof setInterval>> = writable(null);
export const store_orderStatus: Writable<string> = writable('');
export const store_onpl: Writable<onplStoreInterface> = writable({
  isCodAvailable: false,
  isConfigEnabled: false,
  showOnpl: false,
  isOnplVisible: false,
});
export const store_finalPayablePrice: Writable<number> = writable(null);
export const store_isPPCOD: Writable<boolean> = writable(false);
export const store_paymentsUiExperiment: Writable<string> = writable('');
export const store_upiIntentFallbackExperiment: Writable<Record<'showPSP' | 'showVPA', boolean>> = writable({
  showPSP: false,
  showVPA: true,
});
export const store_upiDesktopQrExperiment: Writable<{ showQR: boolean; gradient: string }> = writable({
  showQR: false,
  gradient: '',
});
export const store_twoStepCODConfirmation: Writable<boolean> = writable(false);
export const store_floatingBtnWithTwoStepCODConfirmation: Writable<boolean> = writable(false);
export const store_paymentOptionsHelpers: Writable<paymentOptionsHelperInterface> = writable({
  getMethodres: false,
  isCodAvailable: false,
  upiMethodAvailable: false,
  codMethod: null,
  methods: [],
});
export const store_previousVpaIds: Writable<string[]> = writable([]);
export const store_userAgentCompatibility: Writable<userAgentCompatibilityInterface> = writable({});
export const store_webviewConfig: Writable<WebviewConfigInterface> = writable({});
export const store_merchantUserAgentCompatibilityConfig: Writable<userAgentCompatibilityInterface> = writable(null);
export const store_prepaidCodUiConfig: Writable<PrepaidCodUiConfigInterface> = writable({});
export const store_capturePaymentConfirmation: Writable<boolean> = writable(false);
export const store_isNativeOtpFlow: Writable<boolean> = writable(false);
export const store_otpFlowDetails: Writable<otpFlowInterface> = writable({
  sessionTime: 0,
  resendOtpInterval: 0,
  otpAttemptsLeft: null,
});
export const store_reapplyEr: Writable<{ status: boolean; callReapply: boolean }> = writable({
  status: false,
  callReapply: false,
});

export const store_showCredInOffers: Writable<CredOfferInterface> = writable({
  isActive: false,
  shouldAutoApply: false,
});

export const store_gyftr: Writable<gyftrInterface> = writable({
  status: false,
  count: null,
  redeemable: null,
  rewardType: '',
  appliedAmount: null,
  appliedGiftCardId: '',
  callGyftr: true,
});
export const store_stackedDiscounts: Writable<StackingStoreInterface> = writable({
  is_active: false,
  list: [],
  autoApplyList: [],
});
export const store_allAppliedDiscounts: Writable<AppliedDiscountInterface[]> = writable([]);
export const store_redirectCcDcInSameTab: Writable<boolean> = writable(false);
export const store_savedCardRequireCvv: Writable<boolean> = writable(false);
export const store_windowRedirectionFlow: Writable<boolean> = writable(false);
export const store_showLimitedPaymentOptions: Writable<boolean> = writable(false);
export const store_openPaymentInIframe: Writable<boolean> = writable(false);
export const store_iframeState: Writable<popupInterface> = writable({
  showPopup: false,
  mode: '',
  component: null,
  componentData: null,
});

export const store_codSlider: Writable<CodSliderInterface> = writable({
  showSlider: false,
  sliderExist: false,
});
export const store_shopifyStoreCredit: Writable<ShopifyStoreCreditInterface> = writable({
  amount: 0,
  applied: false,
  callMethods: false,
  available: false,
  balance: 0,
  appliedAmount: 0,
});

export const store_showTwidBasedOnRisk: Writable<SnapmintExpInterface> = writable({ variant: '', risk: '' });
export const store_showSnapmintBasedOnRisk: Writable<SnapmintExpInterface> = writable({ variant: '', risk: '' });
export const store_showSnapmintBasedOnUPI: Writable<SnapmintExpInterface> = writable({
  variant: '',
  upiAvailable: false,
});
export const store_upiAppsConfig: Writable<UpiAppConfig> = writable({ upiSection: {}, preferredPanel: {} });
export const store_upiAppsConfigExperiment: Writable<string> = writable('');
export const store_utmDiscounts: Writable<utmDiscountInterface[]> = writable([]);
export const store_riskFlag: Writable<string> = writable('');
export const store_mrpDiscountData: Writable<mrpDiscountDataInterface> = writable();
export const store_isGokwikBnpl: Writable<boolean> = writable(false);
export const store_showHideGokwkBnpl: Writable<string> = writable('');
export const store_preventScroll: Writable<boolean> = writable(false);
export const store_loggedOffers: Writable<Record<string, boolean>> = writable({});
export const store_twidCachedResponse: Writable<any> = writable([]);
export const store_showDiscountBasedOnRisk: Writable<{ kwikAiFlag: boolean; variant: string }> = writable({
  kwikAiFlag: false,
  variant: '',
});
export const store_isSuccessFlowEnabled: Writable<boolean> = writable(false);
export const store_oneClickPaymentExperiment: Writable<string> = writable('');
export const store_showFullPriceOnPpcod: Writable<boolean> = writable(false);
export const store_showCodSecond: Writable<boolean> = writable(false);
export const store_showMethodNameAsPPCOD: Writable<string> = writable('');
export const store_autoSelectedOffer: Writable<availableOffersInterface | null> = writable(null);
export const store_offersUxExperiment: Writable<boolean> = writable(false);
export const store_pspBtnExperiment: Writable<string> = writable('');
export const store_sbiEmiExperiment: Writable<{ showBtn: boolean; redirectToPlans: boolean }> = writable({
  showBtn: false,
  redirectToPlans: false,
});
export const store_addConfirmationStepExperiment: Writable<boolean> = writable(false);
export const store_codOtpOrderPlaced: Writable<boolean> = writable(false);
export const store_selectedPaymentOption: Writable<paymentButtonInterface | null> = writable(null);
export const store_showSlashPricing: Writable<string> = writable('');
export const store_hideMethodPricing: Writable<boolean | null> = writable(null);
export const store_showHidePaymentOffers: Writable<string> = writable('');
export const store_tieredPricingExperiment: Writable<string> = writable('');
export const store_showHideSnapmintExp: Writable<string> = writable('');
export const store_syncOldUiInMobileExperiment: Writable<string> = writable('');
export const store_syncOldUiInDesktopExperiment: Writable<boolean> = writable(false);
